import React, { useRef } from 'react';
import { ActionButton } from '@manulife/mux';
import { Delete } from '@manulife/mux-cds-icons';
import { FieldType } from './TableFilterInputField';
import { dateRangeFieldNames } from './InputFields/TableFilterDatePicker';
import { useTranslation } from './translationContext';

const TableFilterRemoveButton = ({
  setSearchAppliedIcon,
  form,
  setVisibleSearchFields,
  field,
  visibleSearchFields,
  filterConfiguration,
  index
}) => {
  const deleteRef = useRef<HTMLButtonElement[]>([]);
  const { t } = useTranslation();

  function handleRemoveClick() {
    const fields = [...visibleSearchFields];
    fields.splice(index, 1);
    setVisibleSearchFields(fields);
    const isDateFieldType = filterConfiguration[field].fieldType === FieldType.DATE;
    const fieldsToChange = isDateFieldType ? dateRangeFieldNames(field) : [field];
    fieldsToChange.forEach(fieldToChange => form.change(fieldToChange as keyof string, ''));
    deleteRef.current.splice(index, 1);
    setSearchAppliedIcon(false);
  }

  return (
    <ActionButton
      id={`delete-button-${field}`}
      className="delete-field filter-delete-btn"
      aria-label={t('tablefilter.delete')}
      icon={<Delete />}
      ref={ref => (deleteRef.current[index] = ref)}
      onClick={handleRemoveClick}>
      {t('tablefilter.delete')}
    </ActionButton>
  );
};

export default TableFilterRemoveButton;
